import { TDocumentApplication } from '~/store/types.ts';
import {
  TManagerForm,
  TResponsiblePersons,
  TResponsiblePersonsForm,
} from '~/modules/remote-banking-contacts/type.ts';
import { formatDateReverse } from '~/helpers/utils';
import { PersonRole } from '~/modules/remote-banking-contacts/constants.tsx';

export const nameDocuments = (current: number, applicationDocumentId: string | null) => {
  if (current === 2) {
    return [
      {
        id: applicationDocumentId,
        idDictWebDocument: applicationDocumentId,
        idDoc: applicationDocumentId,
        nameDoc: 'Згода на обробку персональних даних',
      },
    ] as TDocumentApplication[];
  } else {
    return [
      {
        id: applicationDocumentId,
        idDictWebDocument: applicationDocumentId,
        idDoc: applicationDocumentId,
        nameDoc: 'Інформація щодо актуальних контактних даних',
      },
    ] as TDocumentApplication[];
  }
};

export const transformManagerFormData = (values: TManagerForm) => {
  const { havePersonalIdentifier, person, ...rest } = values as TManagerForm;

  if (!person) return { ...rest };

  return {
    ...rest,
    person: {
      ...person,
      ...(person.lastName && { lastName: person.lastName.trim() }),
      ...(person.firstName && { firstName: person.firstName.trim() }),
      ...(person.middleName && { middleName: person.middleName.trim() }),
      ...(person.birthDate && { birthDate: formatDateReverse(person.birthDate) }),
      ...(person.documentInfo && {
        documentInfo: {
          ...person.documentInfo,
          documentTypeId:
            Number(person.documentInfo.documentTypeId?.value) ||
            Number(person.documentInfo.documentTypeId),
        },
      }),
    },
  };
};

export const transformResponsiblePersonsFormData = (values: TResponsiblePersonsForm) => {
  const personsArray = (values as unknown as Record<string, unknown>)
    .formPersons as TResponsiblePersons;

  return personsArray
    .filter(
      (person) =>
        person.personRole !== PersonRole.DIRECTOR && person.personRole !== PersonRole.SOLE_TRADER
    )
    .map((person) => ({
      id: Number(person.id),
      email: person.email,
      phoneNumber: person.phoneNumber,
    }));
};

export const formatBirthDate = (date?: string) => {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
};
